import { render, staticRenderFns } from "./update-blog.html?vue&type=template&id=db527ac4&scoped=true&external"
import script from "./update-blog.js?vue&type=script&lang=js&external"
export * from "./update-blog.js?vue&type=script&lang=js&external"
import style0 from "./update-blog.scss?vue&type=style&index=0&id=db527ac4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db527ac4",
  null
  
)

export default component.exports